/**
 * @generated SignedSource<<117bc721eb645cd6ae76146e94bffd56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OriginalEstimateCell$data = {
  readonly id: string;
  readonly issue: {
    readonly timeTrackingField: {
      readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "OriginalEstimateCell";
};
export type OriginalEstimateCell$key = {
  readonly " $data"?: OriginalEstimateCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "OriginalEstimateCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                }
              ],
              "kind": "FragmentSpread",
              "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraOriginalTimeEstimateField"
};

(node as any).hash = "6dac9d8940c4d8f0a9099192b46018ab";

export default node;
